'use es6';

import http from 'hub-http/clients/apiClient';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
import { formatPathSlug } from 'DesignData/lib/path';
const BASE_API_PATH = 'designmanager/v1/templates';
/**
 * GET /designmanager/v1/templates/:templateId/buffer
 *
 * @param {Number}          templateId - Optional query params.
 * @param {Object}          query - Optional query params.
 */

export function fetch(templateId, query = {}) {
  return http.get(`${BASE_API_PATH}/${templateId}/buffer`, {
    query
  });
}
/**
 * PUT /designmanager/v1/templates/:id/buffer
 */

export function save(templateId, template) {
  return http.put(`${BASE_API_PATH}/${templateId}/buffer/raw`, {
    data: template,
    timeout: 30000
  });
}
/**
 * POST /designmanager/v1/templates/:id/discard-buffer
 */

export function discardBuffer(templateId) {
  return http.post(`${BASE_API_PATH}/${templateId}/discard-buffer`);
}
/**
 * POST /designmanager/v1/templates
 */

export function create(template) {
  return http.post(BASE_API_PATH, {
    data: template
  });
}
/**
 * PUT /designmanager/v1/templates/:id/push-buffer-live
 *
 * Body must be empty.
 */

export function publish(templateId, template) {
  const {
    source,
    isAvailableForNewContent
  } = template;
  return http.put(`${BASE_API_PATH}/${templateId}/push-buffer-live`, {
    data: {
      source,
      isAvailableForNewContent
    },
    timeout: 15000
  });
}
/**
 * PUT /designmanager/v1/templates/:id
 */

export function moveRename(templateId, template) {
  return http.put(`${BASE_API_PATH}/${templateId}`, {
    data: Object.assign({}, template, {
      meta: {
        hasBufferedChanges: false
      }
    })
  });
}
/**
 * DELETE /designmanager/v1/templates/:id
 */

export function deleteTemplate(templateId) {
  return http.delete(`${BASE_API_PATH}/${templateId}`);
}
/**
 * POST /designmanager/v1/templates/:id/clone
 */

export function clone(templateId, template) {
  return http.post(`${BASE_API_PATH}/${templateId}/clone`, {
    data: template
  });
}
/**
 * PUT /designmanager/v1/templates/buffers/by-path/p:path
 */

export function saveByPath(templatePath, template) {
  return http.put(`${BASE_API_PATH}/buffer/by-path/${formatPathSlug(templatePath)}`, {
    data: template,
    query: {
      environmentId: STAGED
    }
  });
}
/**
 * POST /designmanager/v1/templates/clone/by-path/p:path
 */

export function cloneByPath(templatePath, template) {
  return http.post(`${BASE_API_PATH}/clone/by-path/${templatePath}`, {
    data: template
  });
}
/*
 * GET /designmanager/v1/templates/by-path/p:path
 */

export function fetchByPath(path) {
  return http.get(`${BASE_API_PATH}/by-path/${formatPathSlug(path)}`, {
    query: {
      environmentId: STAGED
    }
  });
}